export default "__VITE_ASSET__BbxX5SSb__"